// https://github.com/timmywil/panzoom
import Panzoom from '@panzoom/panzoom'
// import panzoom from 'panzoom';
import tippy from 'tippy.js';
import inView from 'in-view'


const { CountUp } = require('countup.js')

function decimalPlaces(num) {
  var match = ('' + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
  if (!match) { return 0; }
  return Math.max(
    0,
    // Number of digits right of decimal point.
    (match[1] ? match[1].length : 0)
    // Adjust for scientific notation.
    - (match[2] ? +match[2] : 0));
}
let counter = 1

export default class Map {
  constructor(el) {
    this.el = el;
    this.parent = el.closest('.map__parent');
    this.inner = el.querySelector('.map__inner');
    this.items = el.getAttribute('data-worldmap');
    this.number = this.parent.querySelector('[data-number]')
    this.showClose = el.getAttribute('data-show-close') === '1';
    this.focusEurope = false
    if (el.getAttribute('data-focus-europe')) {
      this.focusEurope = true
    }

    this.uniqueId = `map-id-${counter}`
    // this.parent.classList.add(`${this.uniqueId}`)
    this.number.classList.add(`${this.uniqueId}`)

    if (this.items !== '') this.items = JSON.parse(this.items);
    // console.log(this.items)

    if (this.items && this.items.length) this.init();

    if (this.number) this.initNumber()

    counter += 1
  }

  initNumber() {
    const options = {
      decimalPlaces: 0,
      separator: `'`
    };
    if (this.number.getAttribute('data-suffix')) {
      options.suffix = ' ' + this.number.getAttribute('data-suffix')
    }
    if (this.number.getAttribute('data-prefix')) {
      options.prefix = this.number.getAttribute('data-prefix') + ' '
    }

    const number_val = this.number.getAttribute('data-number')
    const numDecimals = decimalPlaces(number_val)
    options.decimalPlaces = numDecimals
    let demo = new CountUp(this.number, parseFloat(number_val), options);

    counter += 1
    if (!demo.error) {
      inView.offset(50)
      inView.threshold(0.35)
      inView(`.${this.uniqueId}`).on('enter', () => {
        demo.start();
      }).on('exit', () => {
        demo.reset()
      })
    } else {
      console.error(demo.error);
    }
  }

  init() {


    // Add is-active class to relevant countries
    const countries = [];
    this.items.forEach((item) => {
      // const country = this.el.querySelector(`#${item.flag}`)
      const country = this.el.querySelector(`.landxx.${item.flag}`);
      // console.log(this.el.querySelectorAll(`#${item.flag}`))
      if (country) {
        country.dataItem = item;
        country.classList.add('is-enabled');
        countries.push(country);
        // country.addEventListener('click', (e) => {
        //   e.preventDefault()
        //   // this.showCountry(country, item)
        // })
      }
      else {
        console.log('Country not found', item);
      }
    });

    // let trigger = showClose ? 'mouseenter click' : 'mouseenter'
    let trigger = this.showClose ? 'click touchstart' : 'mouseenter'
    trigger = 'mouseenter click touchstart'
    const {el} = this;
    let instances = null;
    instances = tippy(countries, {
      content(reference) {
        const {flag} = reference.dataItem;
        // console.log(`[data-country="${flag}"]`)
        const template = el.querySelector(`[data-country="${flag}"]`);
        return template.innerHTML;
      },
      // boundary: this.el.closest('.map__parent'),
      popperOptions: {
        modifiers: [
          {
            name: 'preventOverflow',
            options: {
              // equivalent to boundary: 'window' in v1, usually NOT necessary in v2
              // boundary: this.el.closest('.map__parent'),
              // boundary: this.el.closest('.map__parent'),
              // rootBoundary: this.el,
              padding: 10,
              rootBoundary: this.el
            }
          }
        ]
      },
      onHide(instance) {
        instance.reference.classList.remove('is-active');
      },
      onClickOutside(instance, event) {
        instance.hide();
      },
      onTrigger(instance, e) {
        // add class to change the bottom arrow if there is a footer (white background)
        if (instance.popper && instance.popper.querySelector('.map-tooltip__footer')) {
          instance.popper.classList.add('has-footer');
        }
        instance.reference.classList.add('is-active');
        // instances.forEach((subinstance) => {
        //   if (subinstance !== instance) {
        //     subinstance.hide()
        //   }
        // })
      },
      appendTo: document.body,
      trigger,
      hideOnClick: false,
      allowHTML: true,
      interactive: true,
      animation: 'shift-toward'
    });

    document.body.addEventListener('click', (e) => {
      // console.log(e)
      const tooltip = e.target.closest('[data-tippy-root]')
      if (tooltip && e.target.closest('.map-tooltip__close')) {
        e.preventDefault()
        tooltip._tippy.hide()
      }
    })
    let focal = null
    let contain = null
    let startScale = 1
    if (this.focusEurope) {
      startScale = 1
      focal = {x: 0, y: -1220}
      contain = 'outside'
    }

    const zoominstance = Panzoom(this.inner, {
      excludeClass: 'is-enabled',
      maxScale: 10,
      minScale: 1,
      startScale,
      contain,
    });


    this.parent.querySelector('[data-bt-zoom-in]').addEventListener('click', (e) => {
      // const px = this.parent.getBoundingClientRect()
      // zoominstance.smoothZoom(px.width * 0.5, px.height * 0.5, 1.5)
      zoominstance.zoomIn()
    })
    this.parent.querySelector('[data-bt-zoom-out]').addEventListener('click', (e) => {
      // const px = this.parent.getBoundingClientRect()
      // zoominstance.smoothZoom(px.width * 0.5, px.height * 0.5, .5)
      zoominstance.zoomOut()
    })
    if (this.focusEurope) {

      setTimeout(() => {
        zoominstance.zoom(3, {
          focal
        })
      }, 100)
    }

    // Upon clicking, remove all trigger event listeners
    // countries.forEach(item => {
    //   item.addEventListener('click', (e) => {
    //     e.preventDefault()
    //     console.log(item._tippy)
    //     // this.showCountry(country, item)
    //     if (item._tippy) item._tippy.set({ trigger: 'manual' })
    //   })
    // })

    // Add this to make it hide when we click outside the tooltip or reference element
    // to reset the trigger and hide the tooltip
    // document.addEventListener('click', event => {
    //   if (
    //     !instance.popper.contains(event.target) &&
    //     !instance.reference.contains(event.target)
    //   ) {
    //     instance.set({ trigger: tippy.defaults.trigger })
    //     instance.hide()
    //   }
    // })
  }
}
